import { useEffect, useState } from "react";
import AlertService from "../../services/AlertService";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { FaDownload, FaEye, FaFileDownload, FaFileInvoiceDollar, FaPencilAlt } from "react-icons/fa";
import { ButtonTip } from "../Common/ButtonTip";
import { useNavigate } from "react-router-dom";
import { InfoObligacionDTO, ObligacionDTO, VoidObligacionDTO } from "../../interfaces/Deudas/DeudasDTO";
import FondoRotativoService from "../../services/FondoRotativoService";
import { GrArticle } from "react-icons/gr";
import { PiCertificateBold } from "react-icons/pi";
import Swal from "sweetalert2";

const alerta = new AlertService();
const fondos = new FondoRotativoService();

interface Props {
    idtipo: number,
    token: string,
    onResponse?: (dataRespuesta: any) => void;
}

export const DeudasTableTipo: React.FC<Props> = ({ idtipo, token }) => {
    const [deudas, setDeudas] = useState<Array<ObligacionDTO>>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [obligacionVer, setObligacionVer] = useState(VoidObligacionDTO());
    const [open, setOpen] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [downloadingE, setDownloadingE] = useState(false);
    let history = useNavigate();

    const formatoMonedaEC = new Intl.NumberFormat("es-EC", {
        style: "currency",
        currency: "USD",
    });

    const goToNavigation = (site: string) => {
        history(site)
        //console.log('Dummy')
    }

    const fetchDeudas = async () => {
        alerta.showLoading('Espere...');
        await fondos.GetObligacionesByTipo(idtipo, token, page)
            .then(data => {
                //console.log(data);
                if (data.status.isSuccessfully) {
                    setDeudas(data.listData);
                    setTotalResults(data.totalResults ?? 0);
                    setTotalPages(data.totalPages ?? 0);
                    setTimeout(() => {
                        alerta.hideLoading();
                    }, 3000);
                } else {
                    alerta.hideLoading();
                    alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema al importar la publicación.');
                }
            })
            .catch(e => {
                console.error(e)
                alerta.hideLoading();
                alerta.alertaAdvertencia('Alerta', 'Ocurrió un problema con el servicio de importación.');
            });
    }

    useEffect(() => {
        fetchDeudas();
    }, [page, pageSize]);

    const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setPageSize(parseInt(event.target.value, 10));
        setPage(0); // Reset page al cambiar tamaño
    };

    function linkDspace(ideref: string): string {
        if (ideref === '' || ideref === null) {
            return '';
        }
        let listaArray: string[] = ideref.split(",");
        let enlace = 'http://192.168.1.125/rest/bitstreams/{ideref}/retrieve';
        enlace = enlace.replace("{ideref}", listaArray[1]);
        return enlace;
    }

    function OpenArchivo(archivo: InfoObligacionDTO) {
        if (archivo.iddecinvinfoobligacion > 0) {
            window.open(linkDspace(archivo.refarchivo), '_blank');
        }
    }

    const handleRow = (row: ObligacionDTO) => {
        //console.log(row);
        goToNavigation('/Deudas/' + row.iddecinvobligacion)
    }

    const handleSeeRow = async (row: ObligacionDTO) => {
        var infosDto: Array<InfoObligacionDTO> = [];
        await fondos.GetObligacionById(row.iddecinvobligacion, token)
            .then(data => {
                //console.log(data);
                if (data.status.isSuccessfully) {
                    infosDto = data.data.infoobligaciondtos;
                }
            })
        row.infoobligaciondtos = infosDto;
        setObligacionVer(row);
        setOpen(true);
    }

    const formatFecha = (fecha?: string | Date | null): string => {
        if (!fecha || fecha === "--/--/----") {
            return "--/--/----";
        }

        // Si ya es Date
        if (fecha instanceof Date) {
            return isNaN(fecha.getTime())
                ? "--/--/----"
                : fecha.toLocaleDateString("es-EC");
        }

        // Si es string DD/MM/YYYY, mostrarlo tal cual
        return fecha;
    };

    useEffect(() => {
        //console.log(estado);
        fetchDeudas();
    }, [idtipo]);

    return (
        <Paper>
            <Stack spacing={2} alignItems="center" sx={{ my: 2 }}>
                {totalPages > 1 ?
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handleChange}
                        color="primary"
                    /> : <></>
                }
            </Stack>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Beneficiario</TableCell>
                            <TableCell>Unidad</TableCell>
                            <TableCell>Responsable de seguimiento</TableCell>
                            <TableCell>Estado</TableCell>
                            <TableCell>Fecha Registro</TableCell>
                            <TableCell>Fecha Liberación</TableCell>
                            <TableCell>Opciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {deudas.map((deuda) => (
                            <TableRow key={deuda.iddecinvobligacion}>
                                <TableCell>{deuda.nombreInvestigador}</TableCell>
                                <TableCell>{deuda.nombreUnidad}</TableCell>
                                <TableCell>{deuda.nombreCustodio}</TableCell>
                                <TableCell>{deuda.textoEstado}</TableCell>
                                <TableCell>
                                    {formatFecha(deuda.fecharegistro)}
                                </TableCell>
                                <TableCell>
                                    {formatFecha(deuda.fechaliberacion)}
                                </TableCell>
                                <TableCell>
                                    <Stack direction="row" spacing={1}>
                                        <ButtonTip placement='top' nombre={"Ver"} onClick={async () => handleSeeRow(deuda)}>
                                            <FaEye />
                                        </ButtonTip>
                                        <ButtonTip placement='top' nombre={"Editar"} onClick={() => handleRow(deuda)}>
                                            <FaPencilAlt />
                                        </ButtonTip>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                        {deudas.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    No hay registros.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* 📌 NUEVA PAGINACIÓN */}
            <Stack spacing={2} alignItems="center" sx={{ my: 2 }}>
                {totalPages > 1 ?
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handleChange}
                        color="primary"
                    /> : <></>
                }
                <br />
            </Stack>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Detalle de Obligación</DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="subtitle2">Investigador</Typography>
                            <Typography>{obligacionVer.nombreInvestigador}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="subtitle2">Custodio</Typography>
                            <Typography>{obligacionVer.nombreCustodio}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="subtitle2">Tipo</Typography>
                            <Typography>{obligacionVer.nombreTipoObligacion}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="subtitle2">Estado</Typography>
                            <Typography>{obligacionVer.textoEstado}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Table>
                                <TableBody>
                                    {obligacionVer.infoobligaciondtos.map((info) => (
                                        <TableRow>
                                            {/* Columna 1: Icono + Texto */}
                                            <TableCell>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 8,
                                                    }}
                                                >
                                                    {info.detalle === 'DOC_PAGO' ? <FaFileInvoiceDollar size={35} /> : info.detalle === 'ART_CIENT' ? <GrArticle size={35} /> : <PiCertificateBold size={35} />}
                                                    <Typography variant="body1">
                                                        {info.detalle === 'DOC_PAGO' ? "Documentos de Pago" : info.detalle === 'ART_CIENT' ? "Artículo Científico" : "Certificado Participación"}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            {/* Columna 2 */}
                                            <TableCell>
                                                <Typography variant="body1">{info.descripcion}</Typography>
                                            </TableCell>
                                            {/* Columna 3 */}
                                            <TableCell>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    disabled={info.refarchivo === "" || info.refarchivo === null}
                                                    startIcon={<FaDownload />}
                                                    onClick={() => OpenArchivo(info)}
                                                >
                                                    Ver
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )
                                    )}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpen(false)} variant="contained">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
}